import { createAction, handleActions } from 'redux-actions';

const setShowSupplierModal = createAction("SCREENS/SUPPLIERS/SET_SHOW_SUPPLIER_MODAL");

const defaultState = false;

const reducer = handleActions(
  {
    [setShowSupplierModal]: (state, action) => action.payload
  },
  defaultState
);

export { setShowSupplierModal, reducer };
